import { Routes } from '@angular/router';
import { coreRoutes } from '@next/core-lib/app';

import { fertilisersOverviewRoutes } from './fertilisers-overview/fertilisers-overview.routes';
import { overviewV2Routes } from './overview-v2/overview-v2.routes';

export const appRoutes: Routes = [...overviewV2Routes, ...fertilisersOverviewRoutes, ...coreRoutes];
